import { useMemo } from 'react';
import dayjs from 'dayjs';
import { CalendarEvent } from '../types';

interface MonthDateCellWrapperProps {
  children: React.ReactNode;
  value: Date;
  events: CalendarEvent[];
}

export function MonthDateCellWrapper({ children, value, events }: MonthDateCellWrapperProps) {
  // Contar eventos neste dia
  const eventsOnDay = useMemo(() => {
    return events.filter(event =>
      dayjs(event.start).isSame(value, 'day')
    );
  }, [events, value]);

  const count = eventsOnDay.length;

  if (count === 0) {
    return <>{children}</>;
  }

  return (
    <div style={{ position: 'relative', height: '100%' }}>
      {children}

      {/* Badge de quantidade */}
      {count > 0 && (
        <div
          style={{
            position: 'absolute',
            top: '2px',
            left: '2px',
            backgroundColor: count > 10 ? '#ff4d4f' : count > 5 ? '#faad14' : '#1890ff',
            color: 'white',
            borderRadius: '10px',
            padding: '0 6px',
            fontSize: '10px',
            fontWeight: 600,
            lineHeight: '16px',
            minWidth: '16px',
            textAlign: 'center',
            zIndex: 1,
          }}
        >
          {count}
        </div>
      )}
    </div>
  );
}
